import React, { useState, useEffect } from 'react';
import { get, post } from '../../../ApiServices/ApiServices';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useForm } from "react-hook-form";
import { setSize, clearSize, setShirtSize } from '../../../redux/profileSlice';
import Container from '../../../Container/Container';

import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import AddGroomDetail from './AddGroomDetail';
import AddDescriptions from './AddDescriptions';
import WeddingEventdetail from './WeddingEventdetail';
import AddBrideDetail from './AddBrideDetail';
import GroomStyleDetail from './GroomStyleDetail';
import GroomsmenStyleDetail from './GroomsmenStyleDetail';
import Loader from '../../Component/Loader';
import moment from 'moment';

function FormParent() {
    const [step, setStep] = useState(1);
    const [Helper, setHelper] = useState(false);
    const [id, setid] = useState(null)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch();
    const ID = location.state?.ID;
    const Help = location.state?.Helper
    const { eventId } = location.state || {}; // ✅ Get eventId from URL

    const profile = useSelector((state) => state.profile.profile);
    useEffect(() => {
        if (Help) {
            setHelper(Help)
        }
    }, [Help])

    const [showShirt, setShowShirt] = useState(true);
    const [showVest, setShowVest] = useState(true);
    const [showShoes, setShowShoes] = useState(true);
    const [showTie, setShowTie] = useState(true)
    const [Showjewelry, setShowjewelry] = useState(true)
    const [ShowPocket, setShowPocket] = useState(true)
    const [Showcoat, setShowcoat] = useState(true)
    const [ShowPant, setShowPant] = useState(true)
    const [Singledata, setSingledata] = useState([])
    const [CopyOrder, setCopyOrder] = useState(false)
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { setValue } = useForm();
    console.log(CopyOrder, "CopyOrder====");


    if (!ID) {
        setTimeout(() => setLoading(false), 1000);

    }


    const Singleorder = async () => {
        try {
            setLoading(true); // Start loading

            const api = `view-wedding-event/${eventId}`;
            const response = await get(api);
            if (response?.status == true) {

                setSingledata(response?.data);
                setid(response?.data?.id)
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
            setLoading(false); // Stop loading regardless of success/error
        }
    };

    useEffect(() => {
        if (eventId) {
            Singleorder()
        }
    }, [eventId])
    const { single_order_style = [] } = Singledata;
    console.log(Singledata, "Singledata", single_order_style, "single_order_style");

    const coat = single_order_style.find(item => item.inventory_category_type === "Coats");
    const pant = single_order_style.find(item => item.inventory_category_type === "Pants");
    const shirt = single_order_style.find(item => item.inventory_category_type === "Shirt");
    const vest = single_order_style.find(item => item.inventory_category_type === "Vests");
    const tie = single_order_style.find(item => item.inventory_category_type === "Ties");
    const pocketSquare = single_order_style.find(item => item.inventory_category_type === "PocketSquare");
    const jewellery = single_order_style.find(item => item.inventory_category_type === "Jewellery");
    const shoes = single_order_style.find(item => item.inventory_category_type === "Shoes");
    useEffect(() => {
        const serializedData = JSON.stringify(coat?.inventory_category?.inventories[0]);
        localStorage.setItem('coatStyle', serializedData);
        localStorage.setItem('coatid', coat?.size);
        localStorage.setItem('size', coat?.size_chart_category_id);

    }, [coat])

    useEffect(() => {
        const serializedData = JSON.stringify(shirt?.inventory_category?.inventories[0]);
        localStorage.setItem('shirtstyle', serializedData);
        localStorage.setItem('size', shirt?.size_chart_category_id);

    }, [shirt])

    useEffect(() => {
        const serializedData = JSON.stringify(pant?.inventory_category?.inventories[0]);
        localStorage.setItem('pantstyle', serializedData);
        localStorage.setItem('size', pant?.size_chart_category_id);

    }, [pant])

    useEffect(() => {
        const serializedData = JSON.stringify(vest?.inventory_category?.inventories[0]);
        localStorage.setItem('Veststyle', serializedData);
        localStorage.setItem('size', vest?.size_chart_category_id);

    }, [vest])


    function convertHeightToInches(height) {
        if (!height) return ""; // Return empty string if height is not provided

        // Split the height string into feet and inches parts
        const parts = height.split(/'|"/);
        const feet = parseInt(parts[0]) || 0;
        const inches = parseInt(parts[1]) || 0;

        // Calculate total inches
        const totalInches = feet * 12 + inches;
        return totalInches;
    }

    const height = Singledata.height;
    const heightInInches = convertHeightToInches(height); // Returns 63
    useEffect(() => {
        if (Singledata) {
            setFormData(prev => ({
                ...prev,
                // Personal Details
                Weddingdate: Helper == false ? (Singledata.wedding_date || "") : "",
                order_for: Singledata.order_for || "Men",
                // ordertype: Singledata.order_type || "",
                Firstname: Singledata.groom_first_name || "",
                event_name: Singledata.event_name || "",
                Lastname: Singledata.groom_last_name || "",
                Address: Singledata.groom_address || "",
                State: Singledata.groom_state || "",
                City: Singledata.groom_city || "",
                ZipCode: Singledata.groom_zip_code || "",
                PhoneNumber: Singledata.groom_phone || "",
                EmailAddress: Singledata.groom_email || "",
                school: Singledata.school || "",


                AlterAcc: Singledata?.account,
                AccountId: Singledata?.user_id,
                event_name: Singledata?.event_name,

                BrideAddress: Singledata.bride_address || "",
                BrideCity: Singledata.bride_city || "",
                BrideEmailAddress: Singledata.bride_email || "",
                BrideName: Singledata.bride_first_name || "",
                bride_last_name: Singledata.bride_last_name || "",

                BridePhoneNumber: Singledata.bride_phone || "",
                BrideState: Singledata.bride_state || "",
                BrideZipCode: Singledata.bride_zip_code || "",



                // order_type: Singledata.order_type || "",
                AlternatePickup: Singledata.is_alt_pickup_enable,
                Affiliated_store: Singledata.store,
                dropShippingswitch: Singledata.is_drop_ship_enable,

                dropShipping: {
                    name: Singledata.name,
                    addressLine1: Singledata.shipping_address,
                    addressLine2: Singledata.shipping_address_line2,
                    city: Singledata.shipping_city,
                    state: Singledata.shipping_state,
                    zipCode: Singledata.shipping_zip,
                    phone: Singledata.shipping_phone,
                },


                Height: heightInInches || "",
                Weight: Singledata?.weight || "",
                Chest: Singledata?.chest || "",
                Overarm: Singledata?.overarm || "",

                Coat: coat?.style || "",
                CoatSize: coat?.size || "",

                GroomMenCoat: "",
                GroomMenPant: "",
                GroomMenShirt: "",
                GroomMenVest: "",
                GroomMenTie: "",
                GroomMenPocket: "",
                GroomMenJewelry: "",
                GroomMenShoes: "",
                GroomMenRentalterm: "",
                GroomMenorder_for: "",

                Pant: pant?.style || "",
                Waist: pant?.size || "",
                hip: pant?.hip || "",
                outseam: pant?.outseam || "",

                Shirt: shirt?.style || "",
                ShirtSize: shirt?.size || "",
                Sleeve: shirt?.sleeve || "",

                Vest: vest?.style || "",
                VestColor: vest?.size || "",

                Tie: tie?.style || "",
                Pocket: pocketSquare?.style || "",
                Jewelry: jewellery?.style || "",
                Shoes: shoes?.style || "",
                ShoesSize: shoes?.size || "",

                Rentalterm: Singledata?.rental_term || "",
                Notes: Singledata.notes || "",
                SubmittedBy: Singledata.submitted_by || "",
                // Add other fields from Singledata as needed


                coatinventory_id: coat?.inventory_id || "",
                Paintinventory_id: pant?.inventory_id || "",
                shirtInventory_id: shirt?.inventory_id || "",
                VestInventory_id: vest?.inventory_id || "",
                TieInventory_id: tie?.inventory_id || "",
                PocketInventory_id: pocketSquare?.inventory_id || "",
                jewelryinventory_id: jewellery?.inventory_id || "",
                ShoesInventory_id: shoes?.inventory_id || "",
            }));
        }
    }, [Singledata]); // This effect runs when Singledata changes


    const [formData, setFormData] = useState({
        // Personal Details
        Weddingdate: Helper == false ? (Singledata.event_date || "") : "",
        // ordertype: Singledata.order_type || "",
        Firstname: Singledata.first_name || "",
        Lastname: Singledata.last_name || "",
        Address: Singledata.address || "",
        State: Singledata.state || "",
        City: Singledata.city || "",
        ZipCode: Singledata.zip_code || "",
        PhoneNumber: Singledata.phone || "",
        EmailAddress: Singledata.email || "",
        school: Singledata.school || "",

        AlterAcc: Singledata?.account,
        AccountId: Singledata?.user_id,

        BrideAddress: Singledata.bride_address || "",
        BrideCity: Singledata.bride_city || "",
        BrideEmailAddress: Singledata.bride_email || "",
        BrideName: Singledata.bride_first_name || "",
        event_name: Singledata?.event_name || "",
        bride_last_name: Singledata.bride_last_name || "",
        BridePhoneNumber: Singledata.bride_phone || "",
        BrideState: Singledata.bride_state || "",
        BrideZipCode: Singledata.bride_zip_code || "",
        // SameAddress: Singledata.school || "",



        GroomMenCoat: "",
        GroomMenPant: "",
        GroomMenShirt: "",
        GroomMenVest: "",
        GroomMenTie: "",
        GroomMenPocket: "",
        GroomMenJewelry: "",
        GroomMenShoes: "",
        GroomMenRentalterm: "",
        GroomMenorder_for: "",

        size_chart_id: "",
        order_for: Singledata.order_for || "Men",
        // order_type: Singledata.order_type || "",
        Affiliated_store: "",
        store_id: null,
        is_logging: "false",
        // Drop Shipping
        dropShippingswitch: false,
        dropShipping: {
            name: Singledata.name || "",
            addressLine1: Singledata.shipping_address || "",
            addressLine2: Singledata.shipping_address_line2 || "",
            city: Singledata.shipping_city || "",
            state: Singledata.shipping_state || "",
            zipCode: Singledata.shipping_zip || "",
            phone: Singledata.shipping_phone || "",
        },




        BrideAddress: "",
        BrideCity: "",
        BrideEmailAddress: "",
        BrideName: "",
        BridePhoneNumber: "",
        BrideState: "",
        BrideZipCode: "",
        SameAddress: "",


        // Measurements
        Height: heightInInches || "",
        Weight: Singledata?.weight || "",
        Weightwo: "",
        Overarm: Singledata?.overarm || "",
        Coat: coat?.style || "",
        CoatSize: coat?.size || "",
        Insleeve: "",
        Pant: pant?.style,
        PantSize: "",
        Shirt: shirt?.style || "",
        ShirtSize: shirt?.size || "",
        Sleeve: shirt?.Sleeve || "",
        Vest: vest?.style || "",
        VestColor: vest?.size || "",
        outseam: pant?.outseam || "",
        Chest: Singledata?.chest || "",
        Tie: tie?.style || "",
        hip: pant?.hip || "",
        Pocket: pocketSquare?.style || "",
        Jewelry: jewellery?.style || "",
        Shoes: shoes?.style || "",
        ShoesSize: shoes?.size || "",
        style: "",

        Waist: pant?.size,
        Rentalterm: Singledata?.rental_term || "",

        // Other fields
        AlternatePickup: false,
        Affiliated_store: "",

        // Inventory IDs
        coatinventory_id: coat?.inventory_id || "",
        Paintinventory_id: pant?.inventory_id || "",
        shirtInventory_id: shirt?.inventory_id || "",
        VestInventory_id: vest?.inventory_id || "",
        TieInventory_id: tie?.inventory_id || "",
        PocketInventory_id: pocketSquare?.inventory_id || "",
        jewelryinventory_id: jewellery?.inventory_id || "",
        ShoesInventory_id: shoes?.inventory_id || "",
        size_chart_category_id: "",

        // Description
        Notes: Singledata.notes || "",
        SubmittedBy: Singledata.measured_by || "",
        NextSlip: ""
    });

    const onNextStep = (data) => {
        console.log(data, "data")
        setFormData(prevData => ({
            ...prevData,
            ...data
        }));
        setStep(step + 1);
    };

    const onBackStep = () => {
        setStep(step - 1);
    };
    function convertInchesToFeet(inches) {
        if (!inches || isNaN(inches)) return `0'0"`; // Handle invalid inputs

        let feet = Math.floor(inches / 12);  // Get whole feet
        let remainingInches = inches % 12;   // Get remaining inches

        return `${feet}'${remainingInches}"`; // Format as 6'4"
    }

    const orderData = useSelector(state => state.singleOrder.data);

    const onFormSubmit = async (addressData) => {

        const { single_order_style = [] } = orderData || {};



        setFormData(prevData => ({
            ...prevData,
            ...addressData
        }));
        const finalData = {
            ...formData,
            ...addressData
        };



        const data = {
            // is_logging: "false",
            status_id: 1,


            ...(profile?.name == "Admin" && {
                user_id: finalData?.AccountId || null,
            }),
            account: finalData?.AlterAcc || profile?.account,
            weekend_date: moment(finalData?.Weddingdate).isoWeekday(6).format("MMM D, YYYY"),


            wedding_date: finalData?.Weddingdate,
            groom_first_name: finalData?.Firstname,
            groom_last_name: finalData?.Lastname,
            event_name: finalData?.event_name,
            groom_address: finalData?.Address,
            groom_state: finalData?.State,
            groom_city: finalData?.City,
            groom_zip_code: finalData?.ZipCode,
            groom_phone: finalData?.PhoneNumber,
            groom_email: finalData?.EmailAddress,
            // school: finalData?.order_type == "Prom Order" ? finalData?.school : "",
            bride_first_name: finalData?.BrideName,
            event_name: finalData?.event_name,
            bride_last_name: finalData?.bride_last_name,
            bride_address: finalData?.BrideAddress,
            wedding_role_id: 8,

            bride_same_address: finalData?.SameAddress,
            bride_state: finalData?.BrideState,
            bride_city: finalData?.BrideCity,
            bride_zip_code: finalData?.BrideZipCode,
            bride_phone: finalData?.BridePhoneNumber,
            bride_email: finalData?.BrideEmailAddress,

            notes: finalData?.Notes,
            submitted_by: finalData?.SubmittedBy,

            is_alt_pickup_enable: finalData?.AlternatePickup || false,
            is_drop_ship_enable: finalData?.dropShippingswitch || false,

            name: finalData?.dropShipping?.name,
            store: finalData?.Affiliated_store,
            store_id: finalData?.store_id,


            shipping_address: finalData?.dropShipping?.addressLine1,
            shipping_address_line2: finalData?.dropShipping?.addressLine2,
            shipping_city: finalData?.dropShipping?.city,
            shipping_state: finalData?.dropShipping?.state,
            shipping_zip: finalData?.dropShipping?.zipCode,
            phone: finalData?.dropShipping?.phone,
            is_groomsman_style_same: null,


            height: null,
            weight: null,
            chest: null,
            overarm: null,
            stylesDataForGroom: [

                finalData?.Coat && {
                    type: "groom",
                    inventory_category_id: 1,
                    inventory_id: finalData?.coatinventory_id,
                    style: finalData?.Coat,
                    inventory_category_type: "Coats",
                    member_id: null,
                    size_chart_category_id: null,
                    size_chart_id: null,
                    size: null,
                    insleeve: null
                },

                finalData?.Pant && {
                    type: "groom",
                    inventory_category_id: 2,
                    inventory_id: finalData?.Paintinventory_id,
                    style: finalData?.Pant,
                    member_id: null,
                    inventory_category_type: "Pants",
                    size_chart_category_id: null,
                    size: null,
                    hip: null,
                    outseam: null
                },

                finalData?.Shirt && {
                    type: "groom",
                    inventory_category_id: 3,
                    inventory_id: finalData?.shirtInventory_id,
                    style: finalData?.Shirt,
                    member_id: null,
                    inventory_category_type: "Shirt",
                    shirt_size: null,
                    size_chart_category_id: null,
                    size: null,
                    sleeve: null
                },

                finalData?.Vest && {
                    type: "groom",
                    inventory_category_id: 4,
                    inventory_id: finalData?.VestInventory_id,
                    style: finalData?.Vest,
                    member_id: null,
                    inventory_category_type: "Vests",

                    size_chart_category_id: null,
                    size: null
                },

                finalData?.Tie && {
                    type: "groom",
                    inventory_category_id: 5,
                    inventory_id: finalData?.TieInventory_id,
                    style: finalData?.Tie,
                    member_id: null,
                    inventory_category_type: "Ties",

                },

                finalData?.Pocket && {
                    type: "groom",
                    inventory_category_id: 8,
                    inventory_id: finalData?.PocketInventory_id,
                    style: finalData?.Pocket,
                    inventory_category_type: "PocketSquare",
                    member_id: null,
                    // size_chart_category_id: null,
                },

                finalData?.Jewelry && {
                    type: "groom",
                    inventory_category_id: 9,
                    inventory_id: finalData?.jewelryinventory_id,
                    style: finalData?.Jewelry,
                    member_id: null,
                    inventory_category_type: "Jewellery",

                },

                finalData?.Shoes && {
                    type: "groom",
                    inventory_category_id: 7,
                    inventory_id: finalData?.ShoesInventory_id,
                    style: finalData?.Shoes,
                    inventory_category_type: "Shoes",
                    member_id: null,
                    size_chart_id: null,
                    size_chart_category_id: null,
                    size: null
                },

            ].filter(Boolean), // Filter out falsy values

            stylesDataForGroommenRef: [
                finalData?.GroomMenCoat && {
                    type: "groomsman",
                    inventory_category_id: 1,
                    inventory_id: finalData?.GroomMencoatinventory_id,
                    style: finalData?.GroomMenCoat,
                    inventory_category_type: "Coats",
                    member_id: null,
                    size_chart_category_id: null,
                    size_chart_id: null,
                    size: null,
                    insleeve: null
                },

                finalData?.GroomMenPant && {
                    type: "groomsman",
                    inventory_category_id: 2,
                    inventory_id: finalData?.GroomMenPaintinventory_id,
                    style: finalData?.GroomMenPant,
                    member_id: null,
                    inventory_category_type: "Pants",
                    size_chart_category_id: null,
                    size: null,
                    hip: null,
                    outseam: null
                },

                finalData?.GroomMenShirt && {
                    type: "groomsman",
                    inventory_category_id: 3,
                    inventory_id: finalData?.GroomMenshirtInventory_id,
                    style: finalData?.GroomMenShirt,
                    member_id: null,
                    inventory_category_type: "Shirt",
                    size_chart_category_id: null,
                    size: null,
                    sleeve: null
                },

                finalData?.GroomMenVest && {
                    type: "groomsman",
                    inventory_category_id: 4,
                    inventory_id: finalData?.GroomMenVestInventory_id,
                    style: finalData?.GroomMenVest,
                    member_id: null,
                    inventory_category_type: "Vests",

                    size_chart_category_id: null,
                    size: null
                },

                finalData?.GroomMenTie && {
                    type: "groomsman",
                    inventory_category_id: 5,
                    inventory_id: finalData?.GroomMenTieInventory_id,
                    style: finalData?.GroomMenTie,
                    member_id: null,
                    inventory_category_type: "Ties",
                },

                finalData?.GroomMenPocket && {
                    type: "groomsman",
                    inventory_category_id: 8,
                    inventory_id: finalData?.GroomMenPocketInventory_id,
                    style: finalData?.GroomMenPocket,
                    inventory_category_type: "PocketSquare",
                    member_id: null,
                },

                finalData?.GroomMenJewelry && {
                    type: "groomsman",
                    inventory_category_id: 9,
                    inventory_id: finalData?.GroomMenjewelryinventory_id,
                    style: finalData?.GroomMenJewelry,
                    member_id: null,
                    inventory_category_type: "Jewellery",
                },

                finalData?.GroomMenShoes && {
                    type: "groomsman",
                    inventory_category_id: 7,
                    inventory_id: finalData?.GroomMenShoesInventory_id,
                    style: finalData?.GroomMenShoes,
                    inventory_category_type: "Shoes",
                    member_id: null,
                    size_chart_id: null,
                    size_chart_category_id: null,
                    size: null
                }
            ].filter(Boolean),
        };


        const updata = {

            ...(profile?.name == "Admin" && {
                user_id: finalData?.AccountId || null,
            }),
            account: finalData?.AlterAcc || profile?.account,

            is_logging: true,
            wedding_date: new Date(finalData?.Weddingdate).toISOString().split("T")[0],
            groom_first_name: finalData?.Firstname,
            groom_last_name: finalData?.Lastname,
            event_name: finalData?.event_name,
            groom_address: finalData?.Address,
            groom_state: finalData?.State,
            groom_city: finalData?.City,
            groom_zip_code: finalData?.ZipCode,
            groom_phone: finalData?.PhoneNumber,
            groom_email: finalData?.EmailAddress,

            // school: finalData?.order_type == "Prom Order" ? finalData?.school : "",
            bride_address: finalData?.BrideAddress,
            event_name: finalData?.event_name,

            bride_first_name: finalData?.BrideName,
            bride_last_name: finalData?.bride_last_name,
            bride_state: finalData?.BrideState,
            bride_city: finalData?.BrideCity,
            bride_zip_code: finalData?.BrideZipCode,
            bride_phone: finalData?.BridePhoneNumber,
            bride_email: finalData?.BrideEmailAddress,
            notes: finalData?.Notes,
            submitted_by: finalData?.SubmittedBy,
        }


        const api = eventId ? `update-wedding-event/${eventId}` : 'create-wedding-event';

        try {
            setIsSubmitting(true);

            const totalData = await post(api, eventId ? updata : data);
            console.log(totalData, "totalData");
            if (totalData?.status == true) {

                navigate("/wedding-event-detail", { state: { eventId: totalData?.data?.id || eventId } })



                const keysToRemove = [
                    'coatStyle',
                    'pantstyle',
                    'shirtstyle',
                    'Veststyle',
                    'GroomMencoatStyle',
                    'GroomMenpantstyle',
                    'GroomMenshirtstyle',
                    'GroomMenVeststyle'
                ];
                setTimeout(() => setIsSubmitting(false), 2000);

                // Remove each key from localStorage
                keysToRemove.forEach(key => {
                    localStorage.removeItem(key);
                });
                toast.success(totalData?.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    closeButton: false,
                });
            }

        } catch (error) {
            toast.error(error.message || 'Failed to submit form. Please try again.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            console.error("Error calling API:", error);
        }
    };


    const onFinalSubmit = async () => {

        try {
            let api;
            let Data;
            let convertedHeight = convertInchesToFeet(formData?.Height);


            // if (location?.pathname == "/add-order") {
            if (showShirt && showVest && showShoes && showTie && Showjewelry && ShowPocket && Showcoat && ShowPant) {
                // If all items are shown, confirm the order
                api = id ? `confirm-single-order/${id}` : '';
                Data = {
                    status_id: 2 // Assuming 2 is the status for confirmed orders
                };
                var totalData = await post(api, Data);

            } else {
                // If any item is hidden, update the order with the current data
                onFormSubmit()
            }
            navigate("/single-order")
            toast.success(totalData?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });

            setFormData({
                // Personal Details
                Weddingdate: "",
                ordertype: "",
                Firstname: "",
                Lastname: "",
                Address: "",
                State: "",
                City: "",
                ZipCode: "",
                phoneNumber: "",
                EmailAddress: "",
                school: "",
                size_chart_id: "",
                bride_last_name: "",
                order_for: "Men",
                order_type: "",
                store_id: null,
                EventName: "",
                AlterAcc: "",
                AccountId: null,
                // Drop Shipping
                dropShippingswitch: false,
                dropShipping: {
                    name: "",
                    addressLine1: "",
                    addressLine2: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    phone: ""
                },

                // Measurements
                Height: "",
                Weight: "",
                Weightwo: "",
                Overarm: "",
                Coat: "",
                CoatSize: "",
                Insleeve: "",
                Pant: "",
                PantSize: "",
                Shirt: "",
                ShirtSize: "",
                Sleeve: "",
                Vest: "",
                VestColor: "",
                outseam: "",
                Chest: "",
                Tie: "",
                hip: "",
                Pocket: "",
                Jewelry: "",
                Shoes: "",
                ShoesSize: "",
                style: "",
                Waist: "",
                Rentalterm: "",
                // Other fields
                AlternatePickup: false,
                Affiliated_store: "",

                // Inventory IDs
                coatinventory_id: "",
                Paintinventory_id: "",
                shirtInventory_id: "",
                VestInventory_id: "",
                TieInventory_id: "",
                PocketInventory_id: "",
                jewelryinventory_id: "",
                ShoesInventory_id: "",
                size_chart_category_id: "",

                // Description
                Notes: "",
                SubmittedBy: "",
                NextSlip: ""
            });
            localStorage.removeItem('coatStyle');
            localStorage.removeItem('pantstyle');
            localStorage.removeItem('shirtstyle');
            localStorage.removeItem('Veststyle');
            localStorage.removeItem('size');
            localStorage.removeItem('coatid');
            setStep(1);
            setid(null)
            dispatch(clearSize());

        }
        catch (error) {
            console.log(error, "error");
            toast.error(error.message || 'Failed to submit form. Please try again.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
        }
    };

    window.addEventListener('beforeunload', () => {
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('pantstyle');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('Veststyle');
        localStorage.removeItem('size');
        localStorage.removeItem('coatid');

        localStorage.removeItem('GroomMenVeststyle');
        localStorage.removeItem('GroomMencoatStyle');
        localStorage.removeItem('GroomMenpantstyle');
        localStorage.removeItem('GroomMenshirtstyle');

    });


    useEffect(() => {
        // alert("oooo")
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('pantstyle');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('Veststyle');
        localStorage.removeItem('Shoesstyle');

        localStorage.removeItem('size');
        localStorage.removeItem('coatid');

        localStorage.removeItem('GroomMenVeststyle');
        localStorage.removeItem('GroomMencoatStyle');
        localStorage.removeItem('GroomMenpantstyle');
        localStorage.removeItem('GroomMenshirtstyle');
        localStorage.removeItem('GroomMenshoestyle');

    }, [])

    const RestShirt = () => {
        // Reset form values using react-hook-form's setValue
        setShowShirt(false)
        setValue("shirtInventory_id", null);
        setValue("Shirt", "");
        setValue("ShirtSize", "");
        setValue("Sleeve", "");
        // Update the formData state
        setFormData(prevData => ({
            ...prevData,
            shirtInventory_id: null,
            Shirt: "",
            ShirtSize: "",
            Sleeve: ""
        }));
        localStorage.removeItem('shirtstyle');
    };
    const ResetVest = () => {
        setShowVest(false);
        setValue("VestInventory_id", null);
        setValue("Vest", "");
        setValue("VestColor", "");

        setFormData(prevData => ({
            ...prevData,
            VestInventory_id: null,
            Vest: "",
            VestColor: "",
        }));
        localStorage.removeItem('Veststyle');
    }


    const ResetShoe = () => {
        setShowShoes(false)
        setValue("ShoesInventory_id", null);
        setValue("Shoes", "");
        // If shared, already reset
        setValue("ShoesSize", "");
        setFormData(prevData => ({
            ...prevData,
            ShoesInventory_id: null,
            Shoes: "",
            ShoesSize: "",
        }));
    }

    const RecetTie = () => {
        setShowTie(false)
        setValue("TieInventory_id", null);
        setValue("Tie", "");

        setFormData(prevData => ({
            ...prevData,
            TieInventory_id: null,
            Tie: "",
        }));
    }

    const RecetPocket = () => {
        setShowPocket(false)
        setValue("PocketInventory_id", null);
        setValue("Pocket", "");

        setFormData(prevData => ({
            ...prevData,
            PocketInventory_id: null,
            Pocket: "",
        }));
    }
    const RecetCoat = () => {
        setValue("coatinventory_id", null);
        setValue("Coat", "");
        setValue("CoatSize", "");
        setValue("Insleeve", "");
        localStorage.removeItem('coatid');
        localStorage.removeItem('size');
        localStorage.removeItem('coatStyle');

        setFormData(prevData => ({
            ...prevData,
            coatinventory_id: null,
            Coat: "",
            CoatSize: "",
            Insleeve: "",
        }));
    }

    const RecetPant = () => {
        setShowPant(false)
        setValue("Paintinventory_id", null);
        setValue("Pant", "");
        setValue("Waist", "");
        setValue("hip", "");
        setValue("outseam", "");
        localStorage.removeItem('pantstyle');

        setFormData(prevData => ({
            ...prevData,
            Paintinventory_id: null,
            Pant: "",
            Waist: "",
            hip: "",
            outseam: "",


        }));


    }
    const ResetJewelry = () => {
        setShowjewelry(false)
        setValue("jewelryinventory_id", null);
        setValue("Jewelry", "");
        setFormData(prevData => ({
            ...prevData,
            jewelryinventory_id: null,
            Jewelry: "",

        }));
    }

    if (loading) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }
    return (
        <div>
            {
                location.pathname == "/add-wedding-order" &&
                <>
                    {step === 1 && (
                        <AddGroomDetail
                            key="step1"
                            onNext={onNextStep}
                            ticket={Singledata?.ticket || ""}
                            initialValues={{
                                Weddingdate: formData.Weddingdate,
                                order_type: formData.order_type,
                                Firstname: formData.Firstname,
                                event_name: formData.event_name,
                                AlterAcc: formData.AlterAcc,
                                AccountId: formData.AccountId,
                                Lastname: formData.Lastname,
                                Address: formData.Address,
                                State: formData.State,
                                City: formData.City,
                                ZipCode: formData.ZipCode,
                                PhoneNumber: formData.PhoneNumber,
                                EmailAddress: formData.EmailAddress,
                                school: formData.school,

                                dropShipping: formData.dropShipping,
                                dropShippingswitch: formData.dropShippingswitch,
                                AlternatePickup: formData.AlternatePickup,
                                Affiliated_store: formData.Affiliated_store,
                                store_id: formData.store_id,
                            }}
                        />
                    )}

                    {step === 2 && (
                        <AddBrideDetail
                            key="step3"
                            onNext={onNextStep}
                            onBack={onBackStep}
                            ticket={Singledata?.ticket || ""}

                            initialValues={{
                                BrideAddress: formData?.BrideAddress,
                                BrideCity: formData?.BrideCity,
                                BrideEmailAddress: formData?.BrideEmailAddress,
                                BrideName: formData?.BrideName,
                                bride_last_name: formData?.bride_last_name,
                                BridePhoneNumber: formData?.BridePhoneNumber,
                                BrideState: formData?.BrideState,
                                BrideZipCode: formData?.BrideZipCode,
                                SameAddress: formData?.SameAddress,

                                Address: formData?.Address || "",
                                State: formData?.State || "",
                                City: formData?.City || "",
                                ZipCode: formData?.ZipCode || "",
                            }}
                        />
                    )}
                    {step === 3 && (
                        <GroomStyleDetail
                            key="step3"
                            onNext={onNextStep}
                            onBack={onBackStep}
                            ticket={Singledata?.ticket || ""}

                            initialValues={{
                                Coat: formData.Coat,
                                Pant: formData.Pant,
                                Shirt: formData.Shirt,
                                Vest: formData.Vest,
                                Tie: formData.Tie,
                                Pocket: formData.Pocket,
                                Jewelry: formData.Jewelry,
                                Shoes: formData.Shoes,
                                Rentalterm: formData.Rentalterm,
                                order_for: formData.order_for,
                            }}
                        />
                    )}

                    {step === 4 && (
                        <GroomsmenStyleDetail
                            key="step3"
                            onNext={onNextStep}
                            onBack={onBackStep}
                            ticket={Singledata?.ticket || ""}

                            initialValues={{
                                GroomMenCoat: formData.GroomMenCoat,
                                GroomMenPant: formData.GroomMenPant,
                                GroomMenShirt: formData.GroomMenShirt,
                                GroomMenVest: formData.GroomMenVest,
                                GroomMenTie: formData.GroomMenTie,
                                GroomMenPocket: formData.GroomMenPocket,
                                GroomMenJewelry: formData.GroomMenJewelry,
                                GroomMenShoes: formData.GroomMenShoes,
                                GroomMenRentalterm: formData.GroomMenRentalterm,
                                GroomMenorder_for: formData.GroomMenorder_for,
                            }}
                        />
                    )}


                    {step == 5 && (
                        <AddDescriptions
                            key="step4"
                            onSubmit={onFormSubmit}
                            ticket={Singledata?.ticket || ""}
                            isSubmitting={isSubmitting}

                            onBack={onBackStep}
                            initialValues={{
                                Notes: formData.Notes,
                                SubmittedBy: formData.SubmittedBy,
                                NextSlip: formData.NextSlip,
                            }}
                        />
                    )}

                    {/* WeddingEventDetail */}

                    {step == 6 && (
                        <WeddingEventdetail
                            key="step5"
                            onRewSubmit={onFinalSubmit}
                            onSubmit={onFormSubmit}
                            RestShirtSubmit={RestShirt}
                            ResetVest={ResetVest}
                            ResetShoe={ResetShoe}
                            ResetJewelry={ResetJewelry}
                            RecetTie={RecetTie}
                            RecetPocket={RecetPocket}
                            RecetCoat={RecetCoat}
                            RecetPant={RecetPant}
                            onBack={onBackStep}
                            refid={id}
                            showShirt={showShirt}
                            setShowShirt={setShowShirt}
                            showVest={showVest}
                            setShowVest={setShowVest}
                            showShoes={showShoes}
                            setShowShoes={setShowShoes}

                            setShowTie={setShowTie}
                            showTie={showTie}
                            setShowPocket={setShowPocket}
                            ShowPocket={ShowPocket}
                            CopyOrder={CopyOrder}
                            setCopyOrder={setCopyOrder}
                            setShowjewelry={setShowjewelry}
                            Showjewelry={Showjewelry}

                            Showcoat={Showcoat}
                            setShowcoat={setShowcoat}

                            ShowPant={ShowPant}
                            setShowPant={setShowPant}

                            initialValues={{
                                Weddingdate: formData.Weddingdate,
                                order_type: formData.order_type,
                                Firstname: formData.Firstname,
                                event_name: formData.event_name,
                                Lastname: formData.Lastname,
                                Address: formData.Address,
                                State: formData.State,
                                City: formData.City,
                                ZipCode: formData.ZipCode,
                                PhoneNumber: formData.PhoneNumber,
                                EmailAddress: formData.EmailAddress,
                                school: formData.school,

                                dropShipping: formData.dropShipping,
                                dropShippingswitch: formData.dropShippingswitch,
                                AlternatePickup: formData.AlternatePickup,
                                Affiliated_store: formData.Affiliated_store,
                                store_id: formData.store_id,


                                Height: formData.Height,
                                Weight: formData.Weight,
                                Weightwo: formData.Weightwo,
                                Overarm: formData.Overarm,
                                Coat: formData.Coat,
                                CoatSize: formData.CoatSize,
                                Insleeve: formData.Insleeve,
                                Pant: formData.Pant,

                                PantSize: formData.PantSize,
                                Shirt: formData.Shirt,
                                ShirtSize: formData.ShirtSize,
                                Sleeve: formData.Sleeve,
                                Vest: formData.Vest,
                                VestColor: formData.VestColor,
                                Tie: formData.Tie,
                                Pocket: formData.Pocket,
                                Jewelry: formData.Jewelry,
                                Shoes: formData.Shoes,
                                ShoesSize: formData.ShoesSize,
                                outseam: formData.outseam,
                                Chest: formData.Chest,
                                style: formData.style,
                                hip: formData.hip,
                                Rentalterm: formData.Rentalterm,
                                order_for: formData.order_for,
                                Waist: formData.Waist,
                                size_chart_id: formData.size_chart_id,
                                Notes: formData.Notes,
                                SubmittedBy: formData.SubmittedBy,
                                NextSlip: formData.NextSlip,
                            }}
                        />
                    )}                </>

            }


            {
                location.pathname != "/add-wedding-order" &&
                <>
                    {step === 1 && (
                        <AddGroomDetail
                            key="step1"
                            onNext={onNextStep}
                            ticket={Singledata?.ticket || ""}
                            initialValues={{
                                Weddingdate: formData.Weddingdate,
                                order_type: formData.order_type,
                                Firstname: formData.Firstname,
                                event_name: formData.event_name,
                                Lastname: formData.Lastname,
                                Address: formData.Address,
                                State: formData.State,
                                City: formData.City,
                                ZipCode: formData.ZipCode,
                                PhoneNumber: formData.PhoneNumber,
                                EmailAddress: formData.EmailAddress,
                                school: formData.school,
                                AlterAcc: formData.AlterAcc,
                                AccountId: formData.AccountId,

                                dropShipping: formData.dropShipping,
                                dropShippingswitch: formData.dropShippingswitch,
                                AlternatePickup: formData.AlternatePickup,
                                Affiliated_store: formData.Affiliated_store,
                                store_id: formData.store_id,
                            }}
                        />
                    )}

                    {step === 2 && (
                        <AddBrideDetail
                            key="step3"
                            onNext={onNextStep}
                            onBack={onBackStep}
                            ticket={Singledata?.ticket || ""}

                            initialValues={{
                                BrideAddress: formData?.BrideAddress || "",
                                BrideCity: formData?.BrideCity || "",
                                BrideEmailAddress: formData?.BrideEmailAddress || "",
                                BrideName: formData?.BrideName || "",
                                bride_last_name: formData?.bride_last_name || "",
                                BridePhoneNumber: formData?.BridePhoneNumber || "",
                                BrideState: formData?.BrideState || "",
                                BrideZipCode: formData?.BrideZipCode || "",
                                SameAddress: formData?.SameAddress || "",
                                Address: formData?.Address || "",
                                State: formData?.State || "",
                                City: formData?.City || "",
                                ZipCode: formData?.ZipCode || "",
                            }}
                        />
                    )}


                    {step == 3 && (
                        <AddDescriptions
                            key="step4"
                            onSubmit={onFormSubmit}
                            ticket={Singledata?.ticket || ""}

                            onBack={onBackStep}
                            initialValues={{
                                Notes: formData.Notes,
                                SubmittedBy: formData.SubmittedBy,
                                NextSlip: formData.NextSlip,
                            }}
                            isSubmitting={isSubmitting}

                        />
                    )}

                    {/* WeddingEventDetail */}

                    {step == 4 && (
                        <WeddingEventdetail
                            key="step5"
                            onRewSubmit={onFinalSubmit}
                            onSubmit={onFormSubmit}
                            RestShirtSubmit={RestShirt}
                            ResetVest={ResetVest}
                            ResetShoe={ResetShoe}
                            ResetJewelry={ResetJewelry}
                            RecetTie={RecetTie}
                            RecetPocket={RecetPocket}
                            RecetCoat={RecetCoat}
                            RecetPant={RecetPant}
                            onBack={onBackStep}
                            refid={id}
                            showShirt={showShirt}
                            setShowShirt={setShowShirt}
                            showVest={showVest}
                            setShowVest={setShowVest}
                            showShoes={showShoes}
                            setShowShoes={setShowShoes}

                            setShowTie={setShowTie}
                            showTie={showTie}
                            setShowPocket={setShowPocket}
                            ShowPocket={ShowPocket}
                            CopyOrder={CopyOrder}
                            setCopyOrder={setCopyOrder}
                            setShowjewelry={setShowjewelry}
                            Showjewelry={Showjewelry}

                            Showcoat={Showcoat}
                            setShowcoat={setShowcoat}

                            ShowPant={ShowPant}
                            setShowPant={setShowPant}

                            initialValues={{
                                Weddingdate: formData.Weddingdate,
                                order_type: formData.order_type,
                                Firstname: formData.Firstname,
                                Lastname: formData.Lastname,
                                Address: formData.Address,
                                State: formData.State,
                                City: formData.City,
                                ZipCode: formData.ZipCode,
                                PhoneNumber: formData.PhoneNumber,
                                EmailAddress: formData.EmailAddress,
                                school: formData.school,

                                dropShipping: formData.dropShipping,
                                dropShippingswitch: formData.dropShippingswitch,
                                AlternatePickup: formData.AlternatePickup,
                                Affiliated_store: formData.Affiliated_store,
                                store_id: formData.store_id,


                                Height: formData.Height,
                                Weight: formData.Weight,
                                Weightwo: formData.Weightwo,
                                Overarm: formData.Overarm,
                                Coat: formData.Coat,
                                CoatSize: formData.CoatSize,
                                Insleeve: formData.Insleeve,
                                Pant: formData.Pant,

                                PantSize: formData.PantSize,
                                Shirt: formData.Shirt,
                                ShirtSize: formData.ShirtSize,
                                Sleeve: formData.Sleeve,
                                Vest: formData.Vest,
                                VestColor: formData.VestColor,
                                Tie: formData.Tie,
                                Pocket: formData.Pocket,
                                Jewelry: formData.Jewelry,
                                Shoes: formData.Shoes,
                                ShoesSize: formData.ShoesSize,
                                outseam: formData.outseam,
                                Chest: formData.Chest,
                                style: formData.style,
                                hip: formData.hip,
                                Rentalterm: formData.Rentalterm,
                                order_for: formData.order_for,
                                Waist: formData.Waist,
                                size_chart_id: formData.size_chart_id,
                                Notes: formData.Notes,
                                SubmittedBy: formData.SubmittedBy,
                                NextSlip: formData.NextSlip,
                            }}
                        />
                    )}                </>

            }

        </div>
    )
}

export default FormParent
